// src/utils/request.js
import axios from 'axios';
import { Toast } from 'vant'; // 可以直接引入 Vant 的轻提示组件用于报错

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || '', // 你的 API 地址
    timeout: 5000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么，例如添加 Token
        // const token = localStorage.getItem('token');
        // if (token) {
        //   config.headers['Authorization'] = 'Bearer ' + token;
        // }
        return config;
    },
    error => {
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        // 这里可以根据你后端的自定义状态码进行判断
        if (res.code !== 200) {
            Toast.fail(res.message || '请求失败');
            return Promise.reject(new Error(res.message || 'Error'));
        } else {
            return res;
        }
    },
    error => {
        Toast.fail(error.message || '网络错误');
        return Promise.reject(error);
    }
);

export default service;
